/* HUFT Kuwait — minimum order progress bar
   Shows how far the cart is from the 5.000 KWD checkout minimum.
   Renders sitewide as a sticky bar, and inline in the cart drawer and cart page.
   Pure overlay: touches no product URLs, no Liquid templates, no cart data. */
(function () {
  'use strict';

  var MIN_KWD   = 5.000;          // merchandise subtotal, excludes delivery
  var CURRENCY  = 'KWD';
  var MINOR     = 100;            // Shopify cart.js reports KWD in hundredths (4.000 KWD -> 400), verified live 20 Sep 2026
  var ORANGE    = '#FF6D1F';
  var GREEN     = '#1E8E5A';
  var KEY       = 'huft-mob';     // dismiss key for the sticky bar, per session

  var T = {
    en: {
      remaining: function (v) { return 'Add ' + v + ' KD more to check out'; },
      ready:     'Minimum reached — you can check out',
      note:      'Minimum order 5.000 KD, delivery not included',
      close:     'Dismiss'
    },
    ar: {
      remaining: function (v) { return 'أضف ' + v + ' د.ك لإتمام الطلب'; },
      ready:     'تم الوصول للحد الأدنى — يمكنك إتمام الطلب',
      note:      'الحد الأدنى للطلب 5.000 د.ك، بدون رسوم التوصيل',
      close:     'إغلاق'
    }
  };

  function isRTL() {
    return document.documentElement.getAttribute('dir') === 'rtl' ||
           document.body.classList.contains('rtl') ||
           (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  }
  function t() { return isRTL() ? T.ar : T.en; }
  function fmt(n) { return n.toFixed(3); }

  /* ---------- styles ---------- */
  function injectCSS() {
    if (document.getElementById('huft-mob-css')) return;
    var s = document.createElement('style');
    s.id = 'huft-mob-css';
    s.textContent = [
      '.huft-mob{font-family:inherit;box-sizing:border-box}',
      '.huft-mob *{box-sizing:border-box}',
      '.huft-mob-inline{margin:12px 0;padding:12px 14px;border:1px solid rgba(0,0,0,.08);',
        'border-radius:8px;background:#FBF7F1}',
      '.huft-mob-sticky{position:fixed;left:12px;right:12px;max-width:560px;margin:0 auto;z-index:9998;',
        'bottom:calc(env(safe-area-inset-bottom,0px) + var(--huft-mob-lift,12px));padding:12px 14px 13px;',
        'background:#fff;border:1px solid rgba(20,17,13,.07);border-radius:14px;',
        'box-shadow:0 8px 28px rgba(20,17,13,.16);visibility:hidden;transform:translateY(calc(100% + 48px));',
        'transition:transform .32s cubic-bezier(.3,1,.3,1)}',
      '.huft-mob-sticky .huft-mob-sub{display:none}',
      '.huft-mob-sticky .huft-mob-row{margin-bottom:8px}',
      '.huft-mob-sticky.is-in{visibility:visible;transform:translateY(0)}',
      '.huft-mob-row{display:flex;align-items:center;gap:10px;margin-bottom:7px}',
      '.huft-mob-msg{flex:1;font-size:13.5px;line-height:1.4;font-weight:700;color:#14110D}',
      '.huft-mob-sub{font-size:11.5px;line-height:1.4;color:#8C877D;margin-top:5px}',
      '.huft-mob-track{position:relative;height:7px;border-radius:99px;background:#EDE7DC;overflow:hidden}',
      '.huft-mob-fill{position:absolute;top:0;bottom:0;width:0;border-radius:99px;',
        'background:' + ORANGE + ';transition:width .4s cubic-bezier(.3,1,.3,1)}',
      '.huft-mob.is-ready .huft-mob-fill{background:' + GREEN + '}',
      '.huft-mob.is-ready .huft-mob-msg{color:' + GREEN + '}',
      '.huft-mob-x{flex:0 0 auto;border:0;background:transparent;cursor:pointer;',
        'font-size:19px;line-height:1;color:#8C877D;padding:2px 4px}',
      'html[dir="rtl"] .huft-mob-fill,body.rtl .huft-mob-fill{left:auto;right:0}',
      '.huft-bms{font-weight:800;letter-spacing:.2px;background:linear-gradient(100deg,currentColor 0%,currentColor 42%,#FFD66B 50%,currentColor 58%,currentColor 100%);',
        'background-size:220% 100%;-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;',
        'animation:huftShine 2.6s linear infinite}',
      '@keyframes huftShine{0%{background-position:120% 0}100%{background-position:-120% 0}}',
      '@media(prefers-reduced-motion:reduce){.huft-bms{animation:none;background:none;-webkit-text-fill-color:currentColor}}',
      '@media(max-width:1024.5px){body.huft-mob-on .back-to-top{bottom:calc(env(safe-area-inset-bottom,0px) + var(--huft-mob-lift,12px) + var(--huft-mob-h,60px) + 12px)!important}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- markup ---------- */
  function build(kind) {
    var w = document.createElement('div');
    w.className = 'huft-mob huft-mob-' + kind;
    w.setAttribute('role', 'status');
    w.setAttribute('aria-live', 'polite');
    w.innerHTML =
      '<div class="huft-mob-row">' +
        '<div class="huft-mob-msg"></div>' +
        (kind === 'sticky' ? '<button type="button" class="huft-mob-x" aria-label="' + t().close + '">×</button>' : '') +
      '</div>' +
      '<div class="huft-mob-track"><div class="huft-mob-fill"></div></div>' +
      '<div class="huft-mob-sub"></div>';
    if (kind === 'sticky') {
      w.querySelector('.huft-mob-x').addEventListener('click', function () {
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        w.classList.remove('is-in');
      });
    }
    return w;
  }

  function paint(el, subtotal) {
    var L = t();
    var pct = Math.max(0, Math.min(100, (subtotal / MIN_KWD) * 100));
    var ready = subtotal >= MIN_KWD;
    var msg = ready ? L.ready : L.remaining(fmt(MIN_KWD - subtotal));
    if (el.classList.contains('is-ready') !== ready) el.classList.toggle('is-ready', ready);
    var fill = el.querySelector('.huft-mob-fill');
    var w = pct + '%';
    if (fill.style.width !== w) fill.style.width = w;
    var m = el.querySelector('.huft-mob-msg');
    if (m.textContent !== msg) m.textContent = msg;          // write only on change
    var sub = el.querySelector('.huft-mob-sub');
    if (sub.textContent !== L.note) sub.textContent = L.note;
  }

  /* ---------- placement ---------- */
  var INLINE_ANCHORS = [
    'form[action*="/cart"] button[name="checkout"]',
    'button[name="checkout"]',
    '.cart__checkout-button',
    '.mini_cart_footer',
    '.cart-drawer__footer'
  ];

  function placeInline(subtotal) {
    var n = 0;
    INLINE_ANCHORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (btn) {
        if (btn.closest('.huft-mob')) return;
        var host = btn.closest('form') || btn.parentNode;
        if (!host || host.__huftMobDone) return;
        host.__huftMobDone = true;                 // one bar per host, ever
        var bar = build('inline');
        host.__huftMobBar = bar;
        btn.parentNode.insertBefore(bar, btn);
        n++;
      });
    });
    document.querySelectorAll('.huft-mob-inline').forEach(function (bar) { paint(bar, subtotal); });
    return n;
  }

  var sticky = null;
  var lastCart = null;   // {subtotal, hasItems} from the most recent /cart.js read

  function overlayOpen() {
    var h = document.documentElement.classList;
    return h.contains('open-drawer') || h.contains('open-minicart') || h.contains('open-search') ||
           !!document.querySelector('.minicart.open, cart-notification.open, .bls__drawer.open');
  }
  function onCartPage() {
    return document.body.classList.contains('template-cart') || new RegExp('^/([a-z]{2}/)?cart/?$').test(location.pathname);
  }

  function placeSticky(subtotal, hasItems) {
    lastCart = { subtotal: subtotal, hasItems: hasItems };
    applySticky();
  }

  /* decide visibility from the last cart read plus the current page state */
  function applySticky() {
    if (!lastCart) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (!sticky) { sticky = build('sticky'); document.body.appendChild(sticky); }
    paint(sticky, lastCart.subtotal);
    var show = lastCart.hasItems && lastCart.subtotal > 0 && lastCart.subtotal < MIN_KWD &&
               !dismissed && !overlayOpen() && !onCartPage();
    sticky.classList.toggle('is-in', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('huft-mob-on', show);
    if (show) document.documentElement.style.setProperty('--huft-mob-h', sticky.offsetHeight + 'px');
    updateLift();
  }

  /* keep the card clear of the theme's mobile nav bar when that bar is actually visible */
  function updateLift() {
    var lift = window.innerWidth > 1024 ? 20 : 12;
    var nav = document.querySelector('.mobile-navigation-bar');
    if (nav) {
      var cs = getComputedStyle(nav);
      var shown = nav.offsetHeight > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.2;
      if (shown) lift = nav.offsetHeight + 10;
    }
    document.documentElement.style.setProperty('--huft-mob-lift', lift + 'px');
  }
  var liftTimer = null;
  function liftSoon() { if (liftTimer) return; liftTimer = setTimeout(function () { liftTimer = null; updateLift(); }, 200); }

  /* ---------- data ---------- */
  var last = -1;
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        if ((cart.currency || '').toUpperCase() !== CURRENCY) {
          if (sticky) sticky.classList.remove('is-in');
          return;
        }
        var subtotal = (cart.items_subtotal_price || 0) / MINOR;
        last = subtotal;
        injectCSS();
        placeInline(subtotal);
        placeSticky(subtotal, (cart.item_count || 0) > 0);
      })
      .catch(function () {});
  }

  /* ---------- cart-change detection ---------- */
  var CART_RE = new RegExp('/cart/(add|change|update|clear)', 'i');
  function hook() {
    var f = window.fetch;
    if (f && !f.__huftMOB) {
      var wrapped = function () {
        var url = arguments[0];
        url = (typeof url === 'string') ? url : (url && url.url) || '';
        return f.apply(this, arguments).then(function (res) {
          if (CART_RE.test(url)) setTimeout(refresh, 120);
          return res;
        });
      };
      wrapped.__huftMOB = true;
      window.fetch = wrapped;
    }
    var open = XMLHttpRequest.prototype.open;
    if (!open.__huftMOB) {
      var patched = function (m, u) {
        if (CART_RE.test(u || '')) this.addEventListener('load', function () { setTimeout(refresh, 120); });
        return open.apply(this, arguments);
      };
      patched.__huftMOB = true;
      XMLHttpRequest.prototype.open = patched;
    }
    ['cart:updated', 'cart:refresh', 'cart:change', 'CartDrawer:open', 'cart-drawer:open']
      .forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(refresh, 120); }); });
  }

  var pending = false;
  function boot() {
    injectCSS();
    hook();
    refresh();
    // re-attach when the drawer or cart section is re-rendered; ignore our own writes, coalesce bursts
    var mo = new MutationObserver(function (records) {
      if (pending || last < 0) return;
      var external = false;
      for (var i = 0; i < records.length; i++) {
        var tgt = records[i].target;
        if (!(tgt && tgt.nodeType === 1 && tgt.closest && tgt.closest('.huft-mob'))) { external = true; break; }
      }
      if (!external) return;
      pending = true;
      setTimeout(function () { pending = false; placeInline(last); }, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // "Buy more, save more" announcement: keep the shimmer even if the editor strips the class
    document.querySelectorAll('#topbar .swiper-slide').forEach(function (sl) {
      if (sl.querySelector('.huft-bms')) return;
      var tx = sl.textContent || '';
      if (/buy more, save more|اشترِ أكثر/i.test(tx)) {
        var strong = sl.querySelector('strong, b');
        if (strong) strong.classList.add('huft-bms');
      }
    });
    var classTick = false;
    new MutationObserver(function () {
      if (classTick) return;
      classTick = true;
      setTimeout(function () { classTick = false; applySticky(); }, 16);
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', liftSoon, { passive: true });
    window.addEventListener('resize', liftSoon);
    updateLift();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
